
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.4996 12H18.9996M19.0842 12.2915L21.4191 19.2662C21.6026 19.8142 21.6943 20.0881 21.6285 20.2569C21.5713 20.4034 21.4486 20.5145 21.2971 20.5567C21.1226 20.6054 20.8592 20.4869 20.3322 20.2497L3.62077 12.7296C3.10644 12.4981 2.84928 12.3824 2.7698 12.2216C2.70074 12.082 2.70074 11.9181 2.7698 11.7784C2.84928 11.6177 3.10645 11.5019 3.62077 11.2705L20.3381 3.74776C20.8634 3.51135 21.1261 3.39315 21.3003 3.44164C21.4517 3.48375 21.5744 3.59454 21.6318 3.74078C21.6978 3.90917 21.6071 4.18255 21.4256 4.72931L19.0836 11.7856C19.0524 11.8795 19.0368 11.9264 19.0307 11.9744C19.0252 12.0171 19.0253 12.0602 19.0308 12.1028C19.0371 12.1508 19.0528 12.1977 19.0842 12.2915Z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    